const EXAMPLES = [
  {
    industry: 'Retail Shop',
    icon: 'ri-store-2-line',
    image: 'https://readdy.ai/api/search-image?query=beautifully%20arranged%20boutique%20retail%20store%20interior%20with%20stylish%20clothing%20and%20accessories%20on%20display%2C%20warm%20inviting%20lighting%2C%20clean%20modern%20shelving%2C%20minimal%20decor%2C%20soft%20natural%20light%20from%20windows%2C%20photorealistic%2C%20no%20text%20overlay%2C%20elegant%20small%20business%20atmosphere%2C%20simple%20neutral%20background&width=600&height=400&seq=smb-ex-retail-01&orientation=landscape',
    hook: 'Everyone\'s shopping online. Here\'s why locals still choose us.',
    headline: 'Shop Local. Get 20% Off Your First Visit.',
    cta: 'Claim My Discount',
    platform: 'Facebook',
    platformIcon: 'ri-facebook-circle-fill',
    result: '+290% more in-store visits',
  },
  {
    industry: 'Restaurant',
    icon: 'ri-restaurant-line',
    image: 'https://readdy.ai/api/search-image?query=delicious%20gourmet%20burger%20and%20fries%20on%20a%20wooden%20board%20in%20a%20cozy%20modern%20restaurant%2C%20warm%20ambient%20lighting%2C%20bokeh%20background%20with%20restaurant%20interior%2C%20professional%20food%20photography%2C%20rich%20colors%2C%20appetizing%20presentation%2C%20no%20text%2C%20simple%20clean%20background%2C%20photorealistic&width=600&height=400&seq=smb-ex-restaurant-01&orientation=landscape',
    hook: 'Tired of the same old dinner spots? Try something worth talking about.',
    headline: 'Fresh. Local. Unforgettable. Book Your Table Tonight.',
    cta: 'Reserve a Table',
    platform: 'Instagram',
    platformIcon: 'ri-instagram-fill',
    result: '3.2x more reservations',
  },
  {
    industry: 'Service Business',
    icon: 'ri-scissors-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20hair%20stylist%20working%20in%20a%20modern%20clean%20salon%2C%20bright%20airy%20interior%20with%20white%20walls%20and%20minimalist%20decor%2C%20skilled%20beautician%20attending%20to%20a%20client%2C%20warm%20natural%20lighting%2C%20photorealistic%2C%20no%20text%2C%20confident%20professional%20atmosphere%2C%20simple%20background&width=600&height=400&seq=smb-ex-salon-01&orientation=landscape',
    hook: 'Your last haircut was fine. Your next one will be perfect.',
    headline: 'Book Online. Walk Out Confident. First Cut 15% Off.',
    cta: 'Book My Appointment',
    platform: 'Google Ads',
    platformIcon: 'ri-google-fill',
    result: '3.8x return on ad spend',
  },
];

export default function SmallBusinessExamples() {
  return (
    <section className="py-20 lg:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">
            Real Ad Examples
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            Industry-Specific Ads That Get Results
          </h2>
          <p className="text-base text-stone-500 max-w-xl mx-auto">
            AdForge knows your business. Here&apos;s what AI-generated{' '}
            <strong>small business advertising</strong> looks like across real industries.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {EXAMPLES.map((ex) => (
            <article
              key={ex.industry}
              className="bg-white rounded-2xl border border-stone-100 overflow-hidden flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={ex.image}
                  alt={`${ex.industry} ad example`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.platformIcon} text-sm text-stone-700`} />
                  </div>
                  <span className="text-xs font-semibold text-stone-700">{ex.platform}</span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1.5 bg-orange-500 rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.icon} text-xs text-white`} />
                  </div>
                  <span className="text-xs font-bold text-white">{ex.industry}</span>
                </div>
              </div>

              <div className="p-6 flex flex-col gap-3 flex-1">
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Hook</p>
                  <p className="text-sm text-stone-700 italic leading-relaxed">&ldquo;{ex.hook}&rdquo;</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Headline</p>
                  <p className="text-base font-bold text-stone-900 leading-snug">{ex.headline}</p>
                </div>
                <div className="mt-auto pt-4 border-t border-stone-100 flex items-center justify-between">
                  <span className="inline-block px-4 py-2 bg-orange-500 text-white text-xs font-bold rounded-lg whitespace-nowrap">
                    {ex.cta}
                  </span>
                  <span className="text-xs font-semibold text-green-600 bg-green-50 border border-green-100 rounded-full px-3 py-1">
                    {ex.result}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center text-sm text-stone-400 mt-8">
          AdForge also works for gyms, bakeries, law firms, real estate agents, e-commerce stores, and more.{' '}
          <a href="/signup" className="text-orange-500 font-semibold hover:underline">Try it free →</a>
        </p>
      </div>
    </section>
  );
}
